export const FULL_DATE = 'MM/DD/YY, h:mm a';
export const DATE = 'MM/DD/YY';
export const TIME = 'h:mm a';
